import { render, staticRenderFns } from "./ProfileLogs.vue?vue&type=template&id=3d09c454&scoped=true"
import script from "./ProfileLogs.vue?vue&type=script&lang=js"
export * from "./ProfileLogs.vue?vue&type=script&lang=js"
import style0 from "./ProfileLogs.vue?vue&type=style&index=0&id=3d09c454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d09c454",
  null
  
)

export default component.exports